import { GrowthBook } from '@growthbook/growthbook'
import { UserDataType } from '../context/types'
import { getCountryFromStr } from '../@core/lib/session'
import authConfig from 'src/configs/auth'
import { Country } from '../types/apps/resto365Countries'

export const growthbook = new GrowthBook({
  enableDevMode: true
})

export const loadGrowthBookFeatures = async (country?: Country): Promise<void> => {
  const currentCountry: Country = country || getCountryFromStr(localStorage.getItem(authConfig.userCountryKeyName))

  let url: string | undefined

  switch (currentCountry) {
    case Country.AUS:
      url = process.env.NEXT_PUBLIC_GROWTHBOOK_API_URL_AU
      break
    case Country.USA:
      url = process.env.NEXT_PUBLIC_GROWTHBOOK_API_URL_US
      break
    default:
      url = process.env.NEXT_PUBLIC_GROWTHBOOK_API_URL_AU
  }

  const resolvedUrl = (url || '').trim()

  if (!resolvedUrl) {
    console.error('GrowthBook API URL not found for country:', currentCountry)

    return
  }

  try {
    const response = await fetch(resolvedUrl)
    const { features, user } = await response.json()

    growthbook.setPayload({ features })

    if (user) {
      const userAttributes = { email: user.email }
      growthbook.setAttributes(userAttributes)
    }
  } catch (error) {
    console.error('Error loading GrowthBook features:', error)
  }
}

export const setGrowthBookAttributes = (attributes: Record<string, any> | UserDataType) => {
  growthbook.setAttributes(attributes)
}
